import * as THREE from 'three';
import { TweenLite, Power2 } from 'gsap';

import { constrainXYZ } from './helper';
import context from './context'

export default class Wrap {

    constructor(props) {

        this.props = props;

		//"desired" values for responsive user input (vs tweens for smooth transitions)
        this.desiredPosition = [0, 0, 0];
        this.desiredRotation = [0, 0, 0];
        this.desiredOffset = [0, 0, 0];
        this.spin = [0, 0, 0];
        this.isTransitioning = false;
        
        this.tweens = [];
        this.wrap = new THREE.Object3D(); //rotation, position
        this.inner = new THREE.Object3D(); //offset, spin
        this.wrap.add(this.inner);

        this.componentDidMount();
    }

    handleMapLoaded = (e) => {

        const defaults = {
            position: [0,0,0],
            rotation: [0,0,0],
            offset: [0,0,0],
            spin: [0,0,0],
            keepspin: false,
            mobilez: null
        }
        const options = Object.assign(defaults, e.detail.options);
        const { position, rotation, offset, spin, keepspin, mobilez } = options;
        
        const tweenDuration = context.isInitial ? 0 : 4;

        //if no keepspin, rotate back to zero
        if(!keepspin) {
            TweenLite.to(this.inner.rotation, tweenDuration, {
                x: (spin[0] / 2) / 180 * Math.PI,
                y: (spin[1] / 2) / 180 * Math.PI,
                z: (spin[2] / 2) / 180 * Math.PI,
                ease: Power2.easeInOut,
                onComplete: () => {
                    this.spin = spin;
                }
            });
        } else {
            this.spin = spin;
        }
        
        
        //only set position and rotation on new page
        //because handleKey will handle it on same page
        if(!e.detail.options.isNewPage) return;
        this.desiredChanged = false;
        this.isTransitioning = true;
        
        let tween;
        //cancel existing tweens
        for(let i=0; i<this.tweens.length; i++) {
            this.tweens[i].kill();
        }
        this.tweens = [];

        //wrap rotation        
        tween = TweenLite.to(this.wrap.rotation, tweenDuration, {
            x: rotation[0] / 180 * Math.PI,
            y: rotation[1] / 180 * Math.PI,
            z: rotation[2] / 180 * Math.PI,
            ease: Power2.easeInOut,
            onComplete: () => {

                this.isTransitioning = false;

                //only set desires when no gamKey happened while transitioning
                if(!this.desiredChanged) {
                    this.desiredRotation = rotation;
                }
            }
        });
        this.tweens.push(tween);

        
        //kill x and y on mobile
        if(context.isPhone) position[0] = position[1] = 0;
        
        //respect mobile z
        if(context.mqSmall.matches && typeof mobilez === 'number') position[2] = mobilez;

        //wrap position
        tween = TweenLite.to(this.wrap.position, tweenDuration, {
            x: position[0],
            y: position[1],
            z: position[2],
            ease: Power2.easeInOut,
            onComplete: () => {

                //only set desires when no gamKey happened while transitioning
                if(!this.desiredChanged) {
                    this.desiredPosition = position;
                }
            }
        });
        this.tweens.push(tween);

        //mesh offset
        if(!context.isPhone) {
            tween = TweenLite.to(this.inner.position, tweenDuration, {
                x: offset[0],
                y: offset[1],
                z: offset[2],
                ease: Power2.easeInOut,
                onComplete: () => {
                    this.desiredOffset = offset;
                }
            });
            this.tweens.push(tween);
        }
    }

    handleKey = (e) => {
        //console.log('handleKey',  e.detail)
        this.desiredChanged = true;
        this.desiredPosition = e.detail.position;
        this.desiredRotation = e.detail.rotation;

        //console.log(this.desiredPosition, this.desiredRotation)
    }

    handleLink = () => {
        this.spin = [0,0,0];
        this.isTransitioning = true;
    }

	componentDidMount = () => {
        window.document.addEventListener('gamKey', this.handleKey);
        window.document.addEventListener('gamLinkLoading', this.handleLink);
        window.document.addEventListener('gamMapLoaded', this.handleMapLoaded);
        this.props.three.scene.add(this.wrap);
        this.props.addLoop(this.animate);
    }
    
    componentWillUnmount = () => {
        window.document.removeEventListener('gamKey', this.handleKey);
        window.document.removeEventListener('gamLinkLoading', this.handleLink);
        window.document.removeEventListener('gamMapLoaded', this.handleMapLoaded);
        this.props.three.scene.remove(this.wrap);
        this.props.removeLoop(this.animate);
    }
    
    animate = () => {

        const delta = Math.min(1, this.props.three.clock.getDelta());
        
        //@TODO only when diff > 0.01
        if(!this.isTransitioning) {

            //@TODO TO_RAD
            //const TO_RAD = 180 * Math.PI;
            //@TODO THREE Vector Math?
            
            //position
            if(!context.isPhone) {
                this.wrap.position.x += (this.desiredPosition[0] - this.wrap.position.x) * delta;
                this.wrap.position.y += (this.desiredPosition[1] - this.wrap.position.y) * delta;
            }
            this.wrap.position.z += (this.desiredPosition[2] - this.wrap.position.z) * delta;

            //rotation
            this.wrap.rotation.x += ((this.desiredRotation[0] / 180 * Math.PI) - this.wrap.rotation.x) * delta;
            this.wrap.rotation.y += ((this.desiredRotation[1] / 180 * Math.PI) - this.wrap.rotation.y) * delta;
            this.wrap.rotation.z += ((this.desiredRotation[2] / 180 * Math.PI) - this.wrap.rotation.z) * delta;

            //spin
            this.inner.rotation.x += this.spin[0] * delta / 180 * Math.PI;
            this.inner.rotation.y += this.spin[1] * delta / 180 * Math.PI;
            this.inner.rotation.z += this.spin[2] * delta / 180 * Math.PI;
            constrainXYZ(this.inner.rotation);

            //offset
            if(!context.isPhone) {
                this.inner.position.x += (this.desiredOffset[0] - this.inner.position.x) * delta;
                this.inner.position.y += (this.desiredOffset[1] - this.inner.position.y) * delta;
                this.inner.position.z += (this.desiredOffset[2] - this.inner.position.z) * delta;
            }
        }
    }
}